import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import PhoneNumberForm from '../../components/Forms/PhoneNumberForm';
import { secureAccountPhoneNumberTitle } from '../../util/helpers/onboardingContentHelpers';
import useApplicationOwnerName from '../../hooks/useApplicationOwnerName';
import themeColors from '../../assets/styles/themeColors';
import useApplicationOwnerCountry from '../../hooks/useApplicationOwnerCountry';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountPhoneNumber = ({ applicantType }) => {
  const { activeMenu, activeItem } = useMenu();
  const applicantName = useApplicationOwnerName(applicantType);
  const { identityCountry } = useApplicationOwnerCountry(applicantType);
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'phone_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={
        identityCountry === 'USA'
          ? activeItem?.previousPath
          : activeItem?.preSkipPath
      }
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagPhoneNumber', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle color={themeColors.colorTextSecondary}>
        {applicantType &&
          secureAccountPhoneNumberTitle(applicantType, applicantName)}
      </HeadingSubtitle>

      <PhoneNumberForm
        applicantType={applicantType}
        nextPath={activeItem?.nextPath}
        skipStepPath={activeItem?.skipPath}
        dependentSkipStepPath={activeItem?.dependentSkipPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

SecureAccountPhoneNumber.propTypes = {
  applicantType: PropTypes.string,
};

export default SecureAccountPhoneNumber;
